import * as gannWheelActions from "./gannWheel/actions";
import { actions as gannWheelReducerActions } from "./gannWheel";
import { loginSuccess, loginFailure, logout, updateProfile } from "./login";
import { resetPlanCreated, setPlanCreated } from "./plan";

export default {
  ...gannWheelActions,
  ...gannWheelReducerActions,
  loginSuccess,
  loginFailure,
  updateProfile,
  logout,
  setPlanCreated,
  resetPlanCreated

};
